import SkeletonPulse from './SkeletonPulse';

const ClipHeaderSkeleton = () => {
  return (
    <div className="flex items-center justify-between px-4 py-1">
      <div className="flex items-center gap-3">
        <SkeletonPulse classname="size-7" />
        <SkeletonPulse classname="h-7 w-60 rounded-md" />
      </div>
      <div className="flex items-center gap-3">
        <SkeletonPulse classname="size-6" />
        <SkeletonPulse classname="size-6" />
        <SkeletonPulse classname="size-6" />
        <SkeletonPulse classname="h-8 w-20 rounded-md" />
        <SkeletonPulse classname="h-8 w-20 rounded-md" />
      </div>
    </div>
  );
};

const PlayerSkeleton = () => {
  return <SkeletonPulse classname="w-3/5 h-3/5" />;
};

const menuItem = new Array(4).fill(0);

const ClipCustomizerSkeleton = () => {
  return (
    <div className="absolute right-0 z-[55] mr-10 flex h-auto flex-col items-center gap-2 self-center rounded-lg bg-white p-3">
      {menuItem.map((_, index) => (
        <SkeletonPulse key={index} classname="size-14 rounded-md" />
      ))}
    </div>
  );
};

const ClipPlayerSkeleton = () => {
  return (
    <div className="size-full">
      <div className="w-full">
        <ClipHeaderSkeleton />
      </div>
      <div className="flex h-full items-center justify-center">
        <PlayerSkeleton />
        <ClipCustomizerSkeleton />
      </div>
    </div>
  );
};

export default ClipPlayerSkeleton;
